import { Chip, chipClasses, styled } from '@mui/material';
import PropTypes from 'prop-types';

const StyledChip = styled(Chip)({
  width: 18,
  height: 18,
  padding: 0,
  [`& .${chipClasses.label}`]: {
    padding: 0,
  },
});

const FiltersBadge = ({ count, ...props }) => {
  if (!count) return;

  return <StyledChip {...props} variant='filled' color='primary' label={count} />;
};

FiltersBadge.propTypes = {
  count: PropTypes.number,
  className: PropTypes.string,
};

export default FiltersBadge;
